// @flow

import type { PropsSchema, BasicProps } from '../../type'

import * as React from 'react'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  style: { [string]: string },
  slidingSpeed?: number,
  children: React.ChildrenArray<React.Node>
};

@computeData()
export default class MarqueeLabelComp extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      key: 'slidingSpeed',
      title: '运动速度',
      type: 'number'
    },
    'separator',
    {
      type: 'style'
    }
  ];
  componentDidMount () {
    let { children, slidingSpeed } = this.props
    if (children && children.size !== 0) {
      let containerBoxW = document.getElementById('marqueeMaxContainer')
      let container2W = document.getElementById('marqueeContainer2')
      let container1W = document.getElementById('marqueeContainer1')
      let containerTotalW = document.getElementById('marqueeContentContainer')
      if (containerBoxW && container2W && container1W && containerTotalW) {
        if (container1W.offsetWidth > containerBoxW.offsetWidth) {
          container1W.style.width = container1W.offsetWidth + 'px'
          container2W.style.width = container1W.offsetWidth + 'px'
          containerTotalW.style.width = container1W.offsetWidth * 2 + 'px'
        } else {
          containerTotalW.style.width = containerBoxW.offsetWidth * 2 + 'px'
          container1W.style.width = containerBoxW.offsetWidth + 'px'
          container2W.style.width = containerBoxW.offsetWidth + 'px'
        }
        setInterval(() => {
          if (container1W && containerBoxW) {
            if (container1W.offsetWidth - containerBoxW.scrollLeft <= 0) {
              containerBoxW.scrollLeft -= container1W.offsetWidth
            } else {
              containerBoxW.scrollLeft++
            }
          }
        }, slidingSpeed || 20)
      }
    }
  }
  render () {
    if (!this.props.visible) {
      return null
    }
    const { style, children } = this.props
    if (style && style.display === 'inline') {
      style.display = 'inline-block'
    }
    style.overflow = 'hidden'
    return (
      <div style={style} id='marqueeMaxContainer'>
        <div id='marqueeContentContainer'>
          <div
            id='marqueeContainer1'
            style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
          >
            {children}
          </div>
          <div
            id='marqueeContainer2'
            style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
          >
            {children}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/MarqueeLabel.js